import React from "react";
import history from "../../utils/history";
const Kim = () => {
  return (
    <div className="prac-profile">
      <div className="profile-image kim"></div>
      <div className="content">
        <h2 className="name">Dr. Kim DiStefano</h2>
        <h5 className="post">LAc DACM</h5>
        <button
          className="btn-consult"
          // onClick={() =>
          //   window.open(
          //     "https://sdhma.janeapp.com/locations/my-herbal-pharmacy/book#/staff_member/24/treatment/544",
          //     "_self"
          //   )
          // }
          onClick={() =>
            history.push("/appointment", {
              id: "1600",
              name: "Dr. Kim DiStefano, LAc DACM",
            })
          }
        >
          Request a consultation
        </button>
        <p>About “Kim”</p>
        <p>
          Dr. Kim's passion for medicine ignited during her upbringing around
          healthcare, leading to a deep-rooted interest in holistic healing
          methods. Her journey, from Dickinson College to a Doctorate in Chinese
          Medicine at Pacific College of Oriental Medicine in New York City and
          San Diego, showcases her dedication to blending Eastern modalities
          with herbal remedies for gynecological disorders, post-operative care,
          and respiratory ailments. Her expertise spans across various
          specialties, including treating depression, orthopedic disorders, and
          chronic pain syndromes. Notably, she's known for crafting herbal
          coffee alternatives that optimize focus and productivity, reflecting
          her innovative approach to healthcare and well-being.
        </p>
        <ul>
          <li>
            Specializes in gynecological disorders, post-operative care, and
            herbal remedies for respiratory ailments.
          </li>
          <li>
            Renowned for creating herbal coffee alternatives to enhance focus
            and productivity, showcasing an innovative approach to holistic
            health.
          </li>
        </ul>
      </div>
    </div>
  );
};
export default Kim;
